import type * as React from 'react';

export interface AgentLogsSMSPanelProps {}

export default function AgentLogsSMSPanel(props: AgentLogsSMSPanelProps): React.JSX.Element {
  return (
    <>
      <div className="card card-tall m-0 p-0">
        <div className="card-body m-0 p-0">test</div>
      </div>
    </>
  );
}
